import JSEncrypt from 'jsencrypt'
const publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCNaTUkBxkcp74w4MislENIeMESvH86R9SsBi6U
TRHUroYR+fwQyaLpTAMin6cOh+u1AG+qGO1QcM875ZMrNKXILD40KlP/qyoish/wk6J73XRruMJi
YN/8fm7dzWMo4VblT5o1y2bi0GLCj/mL9xbQFUS0GmAcYifsKKUmJxlN8QIDAQAB`
const encrypt = new JSEncrypt()
encrypt.setPublicKey(publicKey)
export default function(Vue) {
  Vue.prototype.$encrypt = encrypt
}
